import { render, staticRenderFns } from "./Fab.vue?vue&type=template&id=37015cae&scoped=true&"
import script from "./Fab.vue?vue&type=script&lang=js&"
export * from "./Fab.vue?vue&type=script&lang=js&"
import style0 from "./Fab.vue?vue&type=style&index=0&id=37015cae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37015cae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBtn,VDialog,VIcon,VMain,VSpeedDial})
